function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  img {\n    width: ", ";\n    height: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { defaultTheme } from '../../../utils';
var StyledIcon = styled.div(_templateObject(), function (_ref) {
  var width = _ref.width;
  return width + "px";
}, function (_ref2) {
  var height = _ref2.height;
  return height + "px";
});

var Icon = function Icon(_ref3) {
  var referenceClass = _ref3.referenceClass,
      width = _ref3.width,
      height = _ref3.height,
      path = _ref3.path,
      label = _ref3.label,
      rest = _objectWithoutPropertiesLoose(_ref3, ["referenceClass", "width", "height", "path", "label"]);

  return /*#__PURE__*/React.createElement(StyledIcon, {
    className: referenceClass,
    width: width,
    height: height
  }, /*#__PURE__*/React.createElement("img", {
    src: path,
    alt: label
  }));
};

Icon.propTypes = process.env.NODE_ENV !== "production" ? {
  referenceClass: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  label: PropTypes.string,
  path: PropTypes.string.isRequired
} : {};
Icon.defaultProps = {
  width: '20',
  height: '20',
  theme: defaultTheme
};
export default Icon;